<template>
  <div class="col-xs-6 selectHeader">
    <select
      id="lang-setter"
      :value="lang"
      name="language-setter"
      class="form-control"
      @change="onLangChange"
    >
      <option value="pl">
        PL
      </option>
      <option value="en">
        EN
      </option>
    </select>
  </div>
</template>

<script>
import i18n from '../translations'
import { mapMutations} from "vuex";
export default {
    computed: {
        lang () {
            return i18n.locale
        }
    },
    methods: {
        ...mapMutations('cart', ['setLanguage']),
        onLangChange ($event) {
            i18n.locale = $event.target.value;
            this.setLanguage($event.target.value);
        }
    }
}
</script>
